<template>
  <section id="new-message-button">
    <div class="container">
      <div class="row">
        <div class="col-12 text-right">
          <b-button v-b-modal.modal-new-message class="btn btn-neue">Erstelle eine neue…</b-button>
          <b-modal ref="modalNewMessage" size="sm" id="modal-new-message" centered class="app-modals" title="Erstelle eine neue…" hide-footer>
            <router-link :to="{ name: 'new_message', query: { type: 'normal' } }" @click.native="hideModal" class="btn btn-neue w-100 my-1">Nachricht</router-link>
            <router-link v-if="!$current_user.parent" :to="{ name: 'new_message', query: { type: 'confirmation' } }" @click.native="hideModal" class="btn btn-neue w-100 my-1">Nachricht mit Bestätigung</router-link>
            <router-link v-if="!$current_user.parent" :to="{ name: 'new_message', query: { type: 'poll' } }" @click.native="hideModal" class="btn btn-neue w-100 my-1">Abstimmung</router-link>
            <router-link v-if="$current_user.parent" :to="{ name: 'new_message', query: { type: 'sick_note' } }" @click.native="hideModal" class="btn btn-neue w-100 my-1">Krankmeldung</router-link>
          </b-modal>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    hideModal() {
      this.$refs.modalNewMessage.hide();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Messages/New/NewMessageButton.vue